module.exports = __webpack_public_path__ + "static/Ivan-Goncharov-cf8f3d373235ba5eef620bf1f7827692.png";